import { DespatchShippingItem } from "../../../../../../models/despatch";
import { SearchAttribute } from "../../../../../../models/search.attribute";
import { DespatchShippingItemToSearch } from "../types";

const useFilterShippingItems = (
  items: DespatchShippingItem[],
  searchAttributes: SearchAttribute[]
) => {
  return searchAttributes.reduce((filteredOrders, searchAttribute) => {
    const { attribute, values } = searchAttribute;

    if (attribute.includes(".")) {
      const [objectName, objectProperty] = attribute.split(".");

      return filteredOrders.filter((despatchProduct: DespatchShippingItemToSearch) => {
        if (objectName === "product") {
          return values.some((value) => {
            const nestedObject = despatchProduct?.container?.[objectName] as any;

            return String(nestedObject?.[objectProperty])
              ?.toLowerCase()
              .includes(value.toLowerCase());
          });
        }

        return values.some((value) => {
          const nestedObject = despatchProduct?.[objectName];

          return String(nestedObject?.[objectProperty])
            ?.toLowerCase()
            .includes(value.toLowerCase());
        });
      });
    }

    return filteredOrders.filter((despatchProduct: DespatchShippingItemToSearch) => {
      return values.some((value) =>
        String(despatchProduct[attribute])?.toLowerCase().includes(value.toLowerCase())
      );
    });
  }, items);
};

export default useFilterShippingItems;
